import { deleteRequest, get, post, postfd, publicPost, put } from "../helpers/apihelpers";

export const CreatePaymentService=async(data)=>{
    try {
        const result = await post(`api/payment/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdatePaymentService=async(data,id)=>{
    try {
        const result = await put(`api/payment/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UploadPaymentFile=async(data)=>{
    try {
        const result = await postfd(`api/payment/upload_file`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetPaymentService=async(id,type)=>{
    try {
        const result = await get(`api/payment/get/${id}?type=${type}`);
        return result;
    } catch (err) {
        return err.response;
    }
}


export const GetPaymentDetailService=async(id)=>{
    try {
        const result = await get(`api/payment/get/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}


export const DeletePaymentService=async(id)=>{
    try {
        const result = await deleteRequest(`api/payment/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}